// import React from 'react'
import React, { useEffect, useState } from 'react';
import { Grid, CardHeader, CardContent, Fade, Typography } from '@material-ui/core';
import Controls from "../components/controls/Controls";
import { Form, useForm } from '../components/controls/useForm';
import { makeStyles } from "@material-ui/core/styles";
import { displayRazorpay, addAffinityUserDetails } from "../helpers/razorpay";
import { addUser } from "../helpers/addUserWithotPayment";
import { initializeCleverTap, pushEventToCleverTap, pushProfileToCleverTap } from '../utils/clevertap';
import useDataStore from '../store/dataStore';
import "../assets/css/abhfl.css"
import { Button as Couponbutton } from '@material-ui/core';
import { v4 as uuidv4 } from 'uuid';
import { checkNotOptional } from '../helpers/helperFunctions';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
const genderItems = [
    { id: 'Male', title: 'Male' },
    { id: 'Female', title: 'Female' }
]
const noUpperAgelimitPartners=["11319587","11193898"];
const initialFValues = {
    id: 0,
    name: '',
    email: '',
    mobile: '',
    city: '',
    gender: 'Male',
    empCode: '',

    isPermanent: false,
    addLine1: '',
    addLine2: '',
    pincode: '',
    dob: null,
    agentname1: '',
    agentid: '',
    subagentid: '',
    uniqueID:'',
    nomineeName:'',
    nomineeRelation:'',
    nomineeAge:'',
    nomineeDob:null
}
const regexFields = {
    'pincode': '^[1-9][0-9]{5}$',
    'mobile': '^[1-9][0-9]{9}$',
    'coupon': '^[a-zA-Z0-9]+$',
    'storecode': '^[a-zA-Z0-9]*$',
    'email' : /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
}
const payLaterPartners=['11318916']
const useStyles = makeStyles({
    root: {
        'padding-top': '25px',
        borderRadius: '15px',
        boxShadow: '0 0 6px 0 rgba(0, 0, 0, 0.16)',
        backgroundColor: '#fff',
        fontFamily: 'Nunito',
        "& h7": {
            fontFamily: 'Nunito',
            fontSize: '20px',
            color: '#0a0e51',
            fontWeight: 'Bold',
            marginLeft: '10px'
        },

        "& h8": {
            fontFamily: 'Nunito',
            fontSize: '12px',
            color: '#0a0e51',
            fontWeight: 'Bold',
            marginLeft: '10px'
        },

        "& #terms_condition": {
            marginLeft: "10%"
        }
    },
    asterisk: {
        color: 'red'
    },
    info: {
        margin: "2.5%",
        borderRadius: "7.5px",
        backgroundColor: "#fff3d5",
        paddingBottom: "10px",
        "& h7": {
          fontFamily: "Nunito",
          fontSize: "8px",
          color: "#0a0e51",
          fontWeight: "Bold",
          marginLeft: "20px",
        },
        "& p": {
          fontFamily: "Nunito",
          fontSize: "10px",
          color: "#0a0e51",
          marginLeft: "20px",
        },
      },

});

export default function EmployeeForm(props) {

    const [discountedprice, setDiscountedprice] = useState(null)
    const [couponApplied, setCouponApplied] = useState(false);
    const [discount, setDiscount] = useState(null)
    const [discounttext,setDiscounttext]=useState("null")
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    // const [showIframe, setShowIframe] = useState(false);

    // const handleOpenPolicy = (e) => {
    //     e.preventDefault(); 
    //     setShowIframe(true); 
    // };
    // const handleCloseIframe = () => {
    //     setShowIframe(false); // Hide the iframe
    // };
   const [payLater,setIsPayLater]=useState(false)
   console.log("source ", localStorage.getItem("source"),"props",props);
   const showSubmitOnly = localStorage.getItem('showSubmitOnly') === 'true';
    const classes = useStyles();
    const tncData = useDataStore((state) => state.data);
    const [isChecked, setIsChecked] = useState(false);
    const [checkboxes, setCheckboxes] = useState(
        tncData.additionalCheckboxes ? tncData.additionalCheckboxes.map(() => false) : []
    );
    console.log("tncData ", tncData);
    const handleCheckbox = (event) => {
        setIsChecked(event.target.checked);
    };
    const validate = (fieldValues = values) => {
        console.log("validation")
        let temp = { ...errors }
        if (formContent.includes('name') && 'name' in fieldValues) {
            temp.name = !fieldValues.name
                ? "This field is required."
                : /\d/.test(fieldValues.name)
                    ? "Numerical values not allowed."
                    : "";
        }
        if (formContent.includes('email') && 'email' in fieldValues && localStorage.getItem('source') !== 'tvs_credit' && localStorage.getItem('source') !== 'tvs_credit_emp')
            temp.email = (regexValidation(fieldValues.email, regexFields.email)) ? "" : "Email is not valid."
        if (formContent.includes('mobile') && 'mobile' in fieldValues)
            temp.mobile = (fieldValues.mobile.length == 10 && regexValidation(fieldValues.mobile, regexFields.mobile)) ? "" : "Minimum 10 numbers required."
        if (formContent.includes('coupon') && 'coupon' in fieldValues) {
            temp.coupon = (localStorage.getItem('source') === 'abhfl')
                            ? (fieldValues.coupon !== 'ABHFL_MB') ? 'Please enter the verification code shared by your ABHFL POC' : ''
                            : (!regexValidation(fieldValues.coupon, regexFields.coupon)) ? 'Invalid coupon format.' : '';
        }
        if (formContent.includes('storecode') && 'storecode' in fieldValues)
            temp.storecode = (fieldValues.storecode.length >= 10 && regexValidation(fieldValues.storecode, regexFields.storecode)) ? "" : "Minimum 10 characters required."

        if (formContent.includes('addLine1') && 'addLine1' in fieldValues) {
            temp.addLine1 = (fieldValues.addLine1 && fieldValues.addLine1.trim() !== "") ? "" : "Address Is Mandatory"
        }
        if (formContent.includes('city') && 'city' in fieldValues)
            temp.city = (fieldValues.city && fieldValues.city.trim() !== "") ? "" : "City Is Mandatory"
        //added only for ekosh_new
        // if (formContent.includes('empCode') && 'empCode' in fieldValues)
        //     temp.empCode = (fieldValues.empCode) ? "" : "Employee Code Is Mandatory"
        //-----
        if (formContent.includes('pincode') && 'pincode' in fieldValues && checkNotOptional('pincode',props.selectedPackage.form))
            temp.pincode = (regexValidation(fieldValues.pincode, regexFields.pincode)) ? "" : "Pincode Is Mandatory";
        if (formContent.includes('dob') && 'dob' in fieldValues){
            const currentYear = new Date().getFullYear();
            const dobYear = fieldValues.dob ? new Date(fieldValues.dob).getFullYear() : null;
            const age = dobYear ? currentYear - dobYear : null;
        
            if (noUpperAgelimitPartners.includes(props.selectedPackage.pmEntityId)) {
                temp.dob = fieldValues.dob
                    ? (age < 18 ? "Age should be greater than 18" : "")
                    : "Date Of Birth Is Mandatory";
            } else {
                temp.dob = fieldValues.dob
                    ? ((age < 18 || age > 75)
                        ? "Age should be greater than 18 and less than 75"
                        : "")
                    : "Date Of Birth Is Mandatory";
            }
        }
        if (formContent.includes('uniqueID') && 'uniqueID' in fieldValues && checkNotOptional('uniqueID',props.selectedPackage.form))
            temp.uniqueID = (fieldValues.uniqueID && fieldValues.uniqueID.trim() !== "") ? "" : "Unique Goverment ID Is Mandatory"
        if (formContent.includes('nomineeName') && 'nomineeName' in fieldValues && checkNotOptional('nomineeName',props.selectedPackage.form))
            temp.nomineeName = (fieldValues.nomineeName && fieldValues.nomineeName.trim() !== "") ? "" : "Nominee Name Is Mandatory"
        if (formContent.includes('nomineeRelation') && 'nomineeRelation' in fieldValues && checkNotOptional('nomineeRelation',props.selectedPackage.form))
            temp.nomineeRelation = (fieldValues.nomineeRelation && fieldValues.nomineeRelation.trim() !== "") ? "" : "Nominee Relation Is Mandatory"
        if (formContent.includes('nomineeAge') && 'nomineeAge' in fieldValues && checkNotOptional('nomineeAge',props.selectedPackage.form))
            temp.nomineeAge = (fieldValues.nomineeAge && fieldValues.nomineeAge.trim() !== "") ? "" : "Nominee Age Is Mandatory"
        if (formContent.includes('nomineeDob') && 'nomineeDob' in fieldValues && checkNotOptional('nomineeDob',props.selectedPackage.form))
        {
            if (!fieldValues.nomineeDob) {
                temp.nomineeDob = "Nominee Date Of Birth Is Mandatory";
              } 
            else {
                const dob = new Date(fieldValues.nomineeDob);
                const age = new Date().getFullYear() - dob.getFullYear();
                if (age < 18 || age > 65) {
                  temp.nomineeDob = "Age should be greater than 18 and less than 65";
                } else {
                  temp.nomineeDob = ""; 
                }
              }
        }

        setErrors({
            ...temp
        })

        if (fieldValues == values)
            return Object.values(temp).every(x => x == "")
    }
    const initialErrorValues = () => {
        let errorValue = {};
        props.selectedPackage.form.filter(item => item.defaultMessage).forEach(value => errorValue[value.value] = value.defaultMessage);
        return errorValue;
    }
    const checkOptional = (field) => {
        let requiredFormField = props.selectedPackage.form.find(item => item.value === field);
        return !(requiredFormField && requiredFormField.isOptional);
    }
    const defaultMessage = (field) => {
        let requiredFormField = props.selectedPackage.form.find(item => item.value === field);
        return requiredFormField ? (requiredFormField.defaultMessage || "") : "";
    }
    const regexValidation = (field, regexVal) => {
        const regex = new RegExp(regexVal);
        return regex.test(field);
    }


    const initialValues = props.prefillData
        ? { ...initialFValues, ...props.prefillData }
        : initialFValues;

    const prefillGender = props.prefillData && props.prefillData.gender;
    const isValidGender = prefillGender === 'Male' || prefillGender === 'Female';

    initialValues.gender = isValidGender ? prefillGender : 'Male';


    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetForm
    } = useForm(initialValues, true, validate, {});

    const handleSubmit = async (e) => {
        e.preventDefault()
        console.log("vals " + JSON.stringify(values));
        let trackingId=JSON.parse(sessionStorage.getItem("trackingid"))
        let itemUniqueId=JSON.parse(sessionStorage.getItem("itemuniqueid"))
        console.log("trackunique",trackingId,itemUniqueId)
        if (validate()) {
            setIsSubmitting(true);
            initializeCleverTap();
            var cleverTapUser =
            {
                "Site": {
                    "Identity": values.email,
                    "Name": values.name,
                    "Phone": "+91".concat(values.mobile),
                    "Email": values.email,
                    "MSG-whatsapp": true
                }
            }

            pushProfileToCleverTap(cleverTapUser);





            const packageId = props.subId ? props.subId : props.selectedPackage.id
            let f;
            const metaData = getMetaData(props.selectedPackage, values);
            let form_data = {
                packageId: packageId,
                PackageName: props.PackageName,
                username: values.name,
                email: values.email,
                phonenumber: values.mobile,
                city: values.city,
                pincode: values.pincode,
                address: values.addLine1 + values.addLine2,
                walletAmount: props.selectedPackage.walletAmount,
                price: price
            }
            gtag("event", "payment_initiated", form_data);


            form_data.source = localStorage.getItem("source")
            pushEventToCleverTap("Affinity Payment Initiated", form_data)

            if (price == 0) {
                f = await addUser(packageId, props.PackageName, price, values, props.selectedPackage.master_policy_no
                    , props.selectedPackage.pmEntityId, members, props.baseURl).then((t) =>
                        console.log("s")
                    )
            }
            // else if (props.selectedPackage.pmEntityId === '11186707') {
            else if(tncData.isCouponCodeFlow || payLater || showSubmitOnly) {
             if(payLater){
                setShowSuccessMessage(true);
             }  
                f = await addAffinityUserDetails(packageId, props.PackageName, price, values, props.selectedPackage.master_policy_no
                    , props.selectedPackage.pmEntityId, members, props.selectedPackage.walletAmount, metaData, tncData.isCouponCodeFlow, payLater).then((t) =>
                        console.log("s"));
                setTimeout(() => {
                window.location.replace((props.baseURl ? props.baseURl : '/home') + '?utm_source=' + localStorage.getItem("source"));
                }, 3000);
            }
            else if(props.selectedPackage.isDiscountedFlow && discountedprice && trackingId && itemUniqueId){
                f = await displayRazorpay(packageId, props.selectedPackage.title, price, values, props.selectedPackage.master_policy_no
                    , props.selectedPackage.pmEntityId, members, props.selectedPackage.walletAmount, metaData, tncData.isCouponCodeFlow, payLater, props.baseURl,trackingId,itemUniqueId,discountedprice,setValues,setDiscountedprice,setDiscounttext).then((t) => {
                        setIsSubmitting(false);
                        console.log("s")
                    })
            }
            else {
                f = await displayRazorpay(packageId, props.selectedPackage.title, price, values, props.selectedPackage.master_policy_no
                    , props.selectedPackage.pmEntityId, members, props.selectedPackage.walletAmount, metaData, tncData.isCouponCodeFlow, payLater, props.baseURl ).then((t) => {
                        setIsSubmitting(false);
                        console.log("s")
                    })
            }
        }
        else {
            console.log("incom")
        }
    }
    const defaultPayButtonText = "Pay ₹ ";


    let members = getMembers(props.selectedPackage, props.subId);
    let formContent = [];
    let price = getPrice(props.selectedPackage, props.subId);
    let strikePrice = props.selectedPackage.showStrikePriceInCheckoutButton && props.selectedPackage.strikePrice || '';
    let payText = props.selectedPackage.checkOutPayButtonText || defaultPayButtonText;
    console.log("walletAmount" + props.selectedPackage.walletAmount);
    let buttonText = payText + strikePrice + price;
    // hideAdditionMemberDetails is redundant if formPages is configured — just omit "members" from formPages[].sections
    let showAdditionalMemberDetails = !props.selectedPackage.hideAdditionMemberDetails;
    let pmEntityId = props.selectedPackage.pmEntityId;
    if (price == 0) {
        buttonText = 'Avail Benefits';
    }
    const createBenForm = (mem) => {
        let table = []
        for (let i = 1; i <= mem; i++) {

            table.push((nameC(i)))
        }
        return (<>{table}</>);
    }
    const nameC = (num) => {
        num = num + 1;
        const labels = ("Member Name " + num);
        const member = ("member_name" + num);

        return (
            <Controls.Input
                label={labels}
                name={member}
                onChange={handleInputChange}

            />

        )

    };
    const generateTextBox = (num) => {
        const labels = num.label;
        const valueOfElement = num.value;
        const defaultMessage = num.defaultMessage || '';
        const isPrefilled = valueOfElement === 'referralCode' || (props.prefillData && props.prefillData[valueOfElement]);

        console.log("valE" + valueOfElement)
        return (
            <Controls.Input
                label={labels}
                name={valueOfElement}
                onChange={!isPrefilled ? handleInputChange : undefined}
                // onChange={handleInputChange}
                error={errors[valueOfElement]}
                defaultMessage={defaultMessage}
                value={values[valueOfElement]}
                readOnly={isPrefilled}
                InputProps={{
                    readOnly: isPrefilled,
                    style: isPrefilled ? { 
                        backgroundColor: '#f5f5f5',
                        cursor: 'not-allowed'
                    } : {}
                }}
            />

        )

    };
    const generateDobSelector = (element) => {
        const fieldName = element.value; 
        const isPrefilled = !!props.prefillData?.[fieldName];
        return (
            <Controls.DatePicker
            key={fieldName}
            name={fieldName}
            label={element.label}
            value={values[fieldName] ? new Date(values[fieldName]) : null}
            onChange={!isPrefilled ? handleInputChange : undefined}
            // onChange={handleInputChange}
            error={errors[fieldName]}
            readOnly={isPrefilled}
            InputProps={{
                readOnly: isPrefilled,
                style: isPrefilled ? { 
                    backgroundColor: '#f5f5f5',
                    cursor: 'not-allowed'
                } : {}
            }}
        />)

    };
    const generateGenderSelection = () => {
        const prefillGender = props.prefillData && props.prefillData.gender;
        const isValidGender = prefillGender === 'Male' || prefillGender === 'Female';

        return (
            <Controls.RadioGroup
                name="gender"
                label="Please select your gender"
                value={values.gender}
                onChange={!isValidGender ? handleInputChange : undefined}
                // onChange={handleInputChange}
                items={genderItems}
                disabled={isValidGender}
            />
        )
    };
    const handleCheckboxChange = (index) => {
        const updatedCheckboxes = [...checkboxes];
        updatedCheckboxes[index] = !updatedCheckboxes[index];
        setCheckboxes(updatedCheckboxes);
    };
    const allChecked = checkboxes.every(checked => checked);

    function agentId() {
        const [agentdetails, setDetails] = useState("")
        useEffect(() => {
            setDetails(JSON.parse(localStorage.getItem("details")))
        })

        if (localStorage.getItem('source') == 'indelmoney' && agentdetails) {
            return (
                <div style={{
                    "display": "flex",
                    "flex-direction": "column",
                    "width": "100%"
                }}>
                    <Controls.Input
                        name="agentname"
                        label="Agent Name"
                        value={agentdetails.Name}
                        readOnly
                    />
                    <Controls.Input
                        name="agentid"
                        label="Agent Id"
                        value={agentdetails.AgentId}
                        readOnly
                    />
                    <Controls.Input
                        name="subagentid"
                        label="Sub AgentID"
                        value={agentdetails.SubAgentId}
                        readOnly
                    />
                </div>

            )

        }
    }

    function personalDetails() {
        let table = [];
        props.selectedPackage.form.forEach(element => {
            console.log(1, element);
            formContent.push(element.value);
            if (element.section == 'personal' && element.type == 'text') {
                table.push(generateTextBox(element))
            }
            else if (element.section == 'personal' && element.type == 'radio') {
                console.log("gender");
                table.push(generateGenderSelection())
            }
            else if (element.section == 'personal' && element.type == 'date') {
                console.log("dob");
                table.push(generateDobSelector(element))
            }


        });
        return (
            <div style={{
                "display": "flex",
                "flex-direction": "column",
                "width": "100%"
            }}>
                <Grid item container direction="row" alignItems="center" justifyContent="center">
                    <h8>{props.selectedPackage.pmEntityId=="11266804" ? "Submit Through Bank Registered Mobile Number Only" : "Personal Details"}</h8>
                </Grid>
                {table}
            </div>
        )



    }
    function addressDetails() {
        let table = [];
        props.selectedPackage.form.forEach(element => {
            formContent.push(element.value);
            if (element.section == 'address' && element.type == 'text') {

                table.push(generateTextBox(element))
            }
            else if (element.section == 'address' && element.type == 'radio') {
                console.log("gender");
                table.push(generateGenderSelection())
            }
            else if (element.section == 'address' && element.type == 'date') {
                console.log("dob");
                table.push(generateDobSelector())
            }


        });
        if (table.length > 0) {
            return (
                <div style={{
                    "display": "flex",
                    "flex-direction": "column",
                    "width": "100%"
                }}>
                    <Grid item xs={12}>
                        <h8>Add Address </h8>
                    </Grid>
                    {table}
                </div>
            )
        }
        else {
            return (<div></div>)
        }
    }
    const beneficiaryPart = () => {
        if (showAdditionalMemberDetails && members > 1)
            return (
                <div style={{
                    "display": "flex",
                    "flex-direction": "column",
                    "width": "100%"
                }}>
                    <Grid item container direction="row" alignItems="center" justifyContent="center">
                        <h8>Additional Member Details</h8>
                    </Grid>


                    {createBenForm(members - 1)}

                </div>)
    }
    const formLoader = () => {
        if (localStorage.getItem('source') == 'mahindra') {
            console.log('mahindra');
            return (
                <Form onSubmit={handleSubmit}>
                    <Grid container className={classes.root} spacing={1}>
                        <Grid item container direction="row" alignItems="center" justifyContent="center">
                            <h7 >Payment Details</h7>
                        </Grid>
                        <Grid item container direction="row" alignItems="center" justifyContent="center">
                            <h8>Personal Details</h8>
                        </Grid>
                        <Grid item xs={12}>
                            <Controls.Input
                                name="name"
                                label="Name"
                                value={values.name}
                                onChange={handleInputChange}
                                error={errors.fullName}
                            />
                            <Controls.RadioGroup
                                name="gender"
                                label="Gender"
                                value={values.gender}
                                onChange={handleInputChange}
                                items={genderItems}
                            />
                            <Controls.DatePicker
                                name="dob"
                                label="Date Of Birth"
                                value={values.dob}
                                onChange={handleInputChange}
                                error={errors.dob}
                            />
                            <Controls.Input
                                label="Email"
                                name="email"
                                value={values.email}
                                onChange={handleInputChange}
                                error={errors.email}
                            />

                            <Controls.Input
                                label="Phone Number"
                                name="mobile"
                                value={values.mobile}
                                onChange={handleInputChange}
                                error={errors.mobile}
                            />

                        </Grid>
                        <Grid item xs={12}>
                            <h8>Add Address</h8>
                        </Grid>
                        <Grid item xs={12}>
                            <Controls.Input
                                label="Address line 1"
                                name="addLine1"
                                value={values.addLine1}
                                onChange={handleInputChange}
                                error={errors.addLine1}
                            />
                            <Controls.Input
                                label="Address line 2"
                                name="addLine2"
                                value={values.addLine2}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Controls.Input
                                label="City"
                                name="city"
                                value={values.city}
                                error={errors.city}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        {/* <Grid item xs={6}>
                            <Controls.Input
                                label="Employee Code"
                                name="empCode"
                                value={values.empCode}
                                error={errors.empCode}
                                onChange={handleInputChange}
                            />
                        </Grid> */}
                        <Grid item xs={6}>
                            <Controls.Input
                                label="Pincode"
                                name="pincode"
                                error={errors.pincode}
                                value={values.pincode}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            {beneficiaryPart()}
                        </Grid>

                        <div style={{ width: "100%", textAlign: "center", margin: "2%" }}>
                            <Controls.Button
                                type="submit"
                                text={price}
                                prefix={payText}
                                strikeText={strikePrice}
                                disabled={isSubmitting}
                            />

                        </div>
                    </Grid>

                </Form>
            )
        }
        

        const generateCoupon = () => {
            const labels = "discountcoupon";
            const valueOfElement = "discountcoupon";
            const defaultMessage = "Discount" || '';
          
            console.log("valE" + valueOfElement);
          
            return (
                <>
              <div 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  gap: '10px',
                marginLeft:"60px",
                marginRight:"40px",
                // border:"2px solid red"
                }}
              >
                
         
        <Controls.Input
          label={labels}
          name={valueOfElement}
          onChange={handleInputChange}
          error={errors[valueOfElement]}
          value={values.discountcoupon}
         
        />
                <Couponbutton
                  variant="contained"
                  color="primary"
                  size="large"
                  style={{
                    width: "120px",
                    // marginBottom: "-20px",
                    height:"55px",
                    marginRight:"20px"
                  }}
                  onClick={handleCoupon}
                >
                  Validate
                </Couponbutton>
    
              </div>
              
               {discounttext === "valid"
                ? couponreactcode()
                : discounttext==="invalid"
                  ? couponreactinvalid()
                  : (
                    <Grid
                      item
                      container
                      justifyContent="center"
                      style={{ marginTop: '7px', minHeight: '10px' }}
                    >
                      <Typography variant="h6" style={{ fontWeight: "bold" }}>
                        {/* Apply Coupon */}
                      </Typography>
                    </Grid>
                  )
              }
              
              </>
            );
          };
          const couponreactcode=()=>{
            return (
                
                <Grid
                item
                container
                // direction="column"
                justifyContent="center"
                // alignItems="center"
                style={{ marginTop: '7px', minHeight: '10px' }} 
            >
                <Fade in={couponApplied} timeout={1000}>
                    
                <Typography variant="h6" style={{ color: "green" ,fontWeight: "bold"  }}>   
                {`Coupon Applied! You get ${discount} off!`}      
               </Typography> 
                    
                </Fade>
            </Grid>
            )
          }
          const couponreactinvalid=()=>{
            return (
                <Grid
                item
                container
                // direction="column"
                justifyContent="center"
                // alignItems="center"
                style={{ marginTop: '7px', minHeight: '10px' }} 
            >
                <Fade in={!couponApplied} timeout={1000}>
                    
                <Typography variant="h6" style={{ color:  "red" ,fontWeight: "bold" }}>
                
                   
                    Invalid Code
                
            </Typography> 
                    
                </Fade>
            </Grid>
            )
          }

          const handleCoupon = async () => {
     
            let data= {
                couponCode: values.discountcoupon,
                pmEntityId: +props.selectedPackage.pmEntityId,
                userId: 205122661,
                userType: "medibuddy",
                items: [
                    {
                        productId: props.selectedPackage.id,
                        contractId: 27623,
                        unitPrice: +props.selectedPackage.price,
                        quantity: 1,
                        itemUniqueId: uuidv4()
                    }
                ]
            }
           
            localStorage.setItem("data",JSON.stringify(data))
    
           
            try {
                const response = await fetch('https://affinity.medibuddy.in/patientswebapp/affinity/applyCoupon', {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(
                       data
                     )
                })
                const resdataapi = await response.json()
               
                let resdata=resdataapi.data.data
                
                let resobject=resdata.messageBody[0]
                
                sessionStorage.setItem("trackingid",JSON.stringify(resdata.trackingId))
                sessionStorage.setItem("itemuniqueid",JSON.stringify(resdata.messageBody[0].itemUniqueId))
                
    
                setDiscountedprice(resobject.totalDiscountedPrice)
                setDiscounttext("valid")
                setCouponApplied(true)
                setDiscount(resobject.unitDiscount)
            
    
               
    
            }
            catch (err) {
                setDiscounttext("invalid")
                setDiscountedprice(null)
                setCouponApplied(false)
                setDiscount(null)
                console.log("Error")
            }
    
        }

        return (
            <Form onSubmit={handleSubmit}>
                <Grid container className={classes.root} spacing={1}>
                    <Grid item container direction="row" justifyContent="center" alignItems="center">
                        <CardHeader title={props.selectedPackage.formTitle ? props.selectedPackage.formTitle :"Payment Details"} />
                    </Grid>
                    {personalDetails()}
                    {
                        props.selectedPackage.isDiscountedFlow?
                        generateCoupon():''
                    }
                    {addressDetails()}
                    {agentId()}
                    <Grid item xs={12}>
                        {beneficiaryPart()}
                    </Grid>

                    {/* The following code is written for a non-mandatory popup, and the logic is implemented in such a way that, after clicking on the hyperlink, instead of opening in a new tab, an iframe will open on the same page.*/}
                    {/* {localStorage.getItem('source') == 'hdfc_bank' ? 
                        <>
                          <Grid item direction="row" id='terms_condition' style={{ display: 'flex', alignItems: 'center' }}>
                            <input name='checkbox' type='checkbox'></input>
                            <h8>
                                I hereby consent to processing of my data for sending me personalized offers on other products and services of HDFC Bank, its affiliates and partners through Call, SMS, WhatsApp, Email or other channels in the manner described in the notice here  
                                <a href="https://views.medibuddy.in/affinity/OtherProductscopy.html" onClick={handleOpenPolicy} rel="noopener noreferrer"> Policy Document</a>
                            </h8>
                          </Grid>
                            {showIframe && (
                                <div style={{position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000}}>
                                    <div
                                        style={{
                                            position: 'relative',
                                            width: '80%',
                                            height: '80%',
                                            backgroundColor: '#fff',
                                            borderRadius: '10px',
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                        }}
                                    >
                                        <iframe
                                            src="https://views.medibuddy.in/affinity/OtherProductscopy.html"
                                            title="Policy Document"
                                            style={{ width: '100%', height: '100%', border: 'none', borderRadius: '10px' }}
                                        ></iframe>
                                        <button onClick={handleCloseIframe} style={{position: 'absolute',top: '10px',right: '10px',backgroundColor: 'red', color: '#fff', border: 'none', borderRadius: '5px', padding: '5px 10px', cursor: 'pointer'}}>
                                            Close
                                        </button>
                                    </div>
                                </div>
                            )}
                        </>
                        : ''
                    } */}
                    {tncData.additionalCheckboxes && tncData.additionalCheckboxes.length > 0 && tncData.additionalCheckboxes.map((checkbox, index) => {
                        return (
                            <Grid key={index} item  direction="row"  id='terms_condition'  style={{ display: 'flex', alignItems: 'center' }}> 
                                <input name={`checkbox${index}`} type='checkbox' checked={checkboxes[index]} onChange={() => handleCheckboxChange(index)}></input>
                                <h8 dangerouslySetInnerHTML={{ __html: checkbox.textInput1.replace(/&#60;/g, "<").replace(/&#62;/g, ">") }} />
                            </Grid>
                        );
                    })}
                    
                    { tncData.tncAbovePayButton ?
                    <Grid item container direction="row" alignItems="left" justifyContent="left" id = 'terms_condition'>
                        { tncData.showTnCcheckbox ? <input name='checkbox' type='checkbox' onChange={handleCheckbox} checked={isChecked}></input> : ''}
                        <h8>{props.selectedPackage.pmEntityId=="11266804" ? "By proceeding to activate membership, you agree to our" : "By proceeding to pay, you agree to our"} <a href={"/terms-and-conditions?utm_source="+localStorage.getItem('source')} target={'_blank'}>Terms & Conditions</a></h8>
                    </Grid> : ''
                    }
                    
                    <div style={{ width: "100%", maxWidth: "480px", margin: "2% auto", textAlign: "center" }}>
                        <Controls.Button
                            type="submit"
                            style={window.innerWidth < 768 ? {
                                ...props.style,
                                    width: "60%",
                                    marginLeft:"20%",
                                    minHeight: "48px"
                            } : props.style}
                            text={
                                (tncData.isCouponCodeFlow || showSubmitOnly)
                                    ? "Submit"
                                    : (discountedprice ? discountedprice : price)
                                }
                            prefix={(tncData.isCouponCodeFlow || showSubmitOnly) ? '' : payText}
                            strikeText={
                                (tncData.isCouponCodeFlow || showSubmitOnly)
                                    ? ''
                                    : (discountedprice ? price : (strikePrice ? strikePrice : ''))
                                }
                            disabled={isSubmitting ||(tncData.showTnCcheckbox && !isChecked) || (tncData.additionalCheckboxes && tncData.additionalCheckboxes.length > 0 && !allChecked)}
                        />
                        <div style={{textAlign: 'center', width: '100%' }}>
                    {props.selectedPackage.priceWithGST && (
                     <i style={{ fontSize: '10px' }}>*inclusive of GST</i>)} </div>

                    {payLaterPartners.includes(props.selectedPackage.pmEntityId) && (
                    <>
                        <div
                            style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "12px 0",
                            fontWeight: "600",
                            color: "#555",
                            }}
                        >
                            <div style={{ width: "40px", height: "1px", background: "#ccc" }}></div>
                            <span style={{ margin: "0 8px" }}>OR</span>
                            <div style={{ width: "40px", height: "1px", background: "#ccc" }}></div>
                        </div>
                        <Controls.Button
                        type="submit"
                        text={`Send payment link to customer`}
                        onClick={() => setIsPayLater(true)}
                        style={
                            window.innerWidth < 768 ? {
                                ...props.style,
                                    width: "60%",
                                    marginLeft:"20%",
                                    minHeight: "48px"
                            } : props.style                                       
                        }
                        />
                    </>
                    )}

                    </div>
                    
                    {
                        (localStorage.getItem('source') == 'bank_of_baroda') ?
                            <CardContent className={classes.info}>
                                <h9> <b>Note: </b></h9>
                                <h9>Dear Bank of Baroda customer, This is an exclusive benefit only applicable if payment is made through your <b>Bank of Baroda Platinum, Sapphire or Opulence debit card.</b> Please note that payment through any other mode will not be accepted to activate this benefit.</h9>
                            </CardContent>
                            : ''
                    }
                   
                {showSuccessMessage && (
                <Grid item xs={12} style={{ marginTop: '20px' }}>
                    <div style={{ 
                        backgroundColor: '#e8f5e9', 
                        color: '#2e7d32', 
                        padding: '15px', 
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    }}>
                        <CheckCircleOutlineIcon style={{ color: '#2e7d32' }} />
                        <div>
                            <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>Payment Link Sent Successfully!</Typography>
                            <Typography variant="body2">We've sent a payment link to {values.mobile}</Typography>
                        </div>
                    </div>
                </Grid>
                )}
                   



                </Grid>

            </Form>)
    }

    return (<div>{formLoader()}</div>)
}
function getMembers(selectedPackage, id) {
    if (!selectedPackage.complexStructure)
        return selectedPackage.members
    else {
        var found = selectedPackage.structure.filter(
            function (item) { return item.subId + '' === id; });
        return found[0].members;
    }

}

function getPrice(selectedPackage, id) {
    if (selectedPackage.discountPercent)
        return (0)
    if (!selectedPackage.complexStructure)
        return (selectedPackage.priceWithGST ? selectedPackage.priceWithGST : selectedPackage.price);
    else {
        var found = selectedPackage.structure.filter(
            function (item) { ; return item.subId + '' === id; });
        return found[0].price
    }
}
function getMetaData(packageform, values) {
    const metadata = {};
    const metadataFields = packageform.form.filter(item => item.isMeta).map(metaField => metaField.value);
    metadataFields.reduce((prev, curr) => metadata[curr] = values[curr], metadata);

    return Object.keys(metadata).length > 0 ? metadata : null;
}
